module.exports = __webpack_public_path__ + "img/professional_learning.73cfd71e.svg";